export default class AdditionalEvents {
    constructor() { }

    init() {
        const additionalArticleCardCaouselCTA: HTMLAnchorElement = document.querySelector('#additionalArticleCardCaouselCTA');

        if ((<any>window).dataLayer && additionalArticleCardCaouselCTA) {
            additionalArticleCardCaouselCTA.addEventListener('click', () => {
                (<any>window).dataLayer.push({
                    'event': 'CAC20 Mobile Extra CTA',
                    'category': 'CTA',
                    'action': 'click',
                    'label': 'member-story-cta',
                    'value': 0
                });
            });
        }
    }
}